"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _options = require("@/store/gettersModule/options");

var getters = (0, _objectSpread2.default)({
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  fingerprint: function fingerprint(state) {
    return state.user.fingerprint;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  account: function account(state) {
    return state.user.accounts;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permissions: function permissions(state) {
    return state.user.permissions;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  title: function title(state) {
    return state.app.title;
  },
  mode: function mode(state) {
    return state.app.mode;
  },
  isAdmin: function isAdmin(state) {
    return state.app.mode === 'admin';
  },
  isAgent: function isAgent(state) {
    return state.app.mode === 'agent';
  },
  isMerchant: function isMerchant(state) {
    return state.app.mode === 'merchant';
  },
  config: function config(state) {
    return state.app.config;
  },
  merchLogo: function merchLogo(state) {
    return state.app.merchLogo;
  },
  themeConf: function themeConf(state) {
    return state.app.themeConf;
  },
  stripeConf: function stripeConf(state) {
    return state.app.stripeConf === '1';
  },
  borderConf: function borderConf(state) {
    return state.app.borderConf === '1';
  },
  plainConf: function plainConf(state) {
    return state.app.plainConf === '1';
  },
  roundConf: function roundConf(state) {
    return state.app.roundConf === '1';
  },
  isForced: function isForced(state) {
    return state.user.isForced;
  },
  isChina: function isChina(state) {
    return process.env.VUE_APP_PLATFORM_TYPE === 'CHINA';
  },
  isInternational: function isInternational(state) {
    return process.env.VUE_APP_PLATFORM_TYPE === 'INTERNATIONAL';
  },
  //exclude China
  isGlobal: function isGlobal(state) {
    return process.env.VUE_APP_PLATFORM_TYPE === 'GLOBAL';
  },
  //include China
  dollarSign: function dollarSign(state) {
    var dollarSign;

    if (process.env.VUE_APP_PLATFORM_TYPE === 'INTERNATIONAL') {
      dollarSign = "(USD)";
    } else {
      dollarSign = "(RMB)";
    }

    return dollarSign;
  },
  isVerified: function isVerified(state) {
    return state.user.isVerified;
  },
  platform: function platform(state) {
    var mode = state.app.mode;
    var overall = state.app.platform;
    var platform = 1;

    if (mode === 'admin') {
      platform = overall.split('-')[0];
    } else if (mode === 'agent') {
      platform = overall.split('-')[1];
    } else if (mode === 'merchant') {
      platform = overall.split('-')[2];
    }

    return platform;
  },
  netwayCodeEnums: function netwayCodeEnums(state) {
    return state.user.netwayCodeEnums;
  }
}, _options.options);
var _default = getters;
exports.default = _default;